<template>
  <div class="cjt-customer" v-show="!hidden">
    <div id="support-launcher" class="support-widget-btn">
      <img class="icon" src="https://static.xyb2b.com/images/044e765b2ee3aa1002f90572c24ecbb2.svg" alt="" />
      <div>咨询</div>
    </div>
    <div class="phone">
      <img class="icon" src="https://static.xyb2b.com/images/76af9d94d49793a86c4c2862112c0563.svg" alt="" />
      <div class="">热线</div>
      <div class="phone-pop">
        <div class="phone-list">
          4008热线: 4001828088
          <div class="arrow" />
        </div>
      </div>
    </div>
    <div class="wx">
      <img class="icon" src="https://static.xyb2b.com/images/9bb6891a4df122b30b6f01fe6aa7b0e1.svg" alt="" />
      <div class="">公众号</div>
      <div class="wx-pop">
        <img src="https://static.xyb2b.com/images/2b1fc007fdfa8e5de0facdca83269768.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enterpriseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hidden: location.pathname.startsWith('/client/embed/') || location.pathname.startsWith('/client/serviceDetailFree'),
    };
  },
  methods: {
    close() {
      this.hidden = true;
    },
  },
};
</script>
<style scoped lang="less">
.cjt-customer {
  position: fixed;
  bottom: 135px;
  right: 10px;
  z-index: 2;
  background-color: white;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 20px 8px;
  font-size: 12px;
  color: #999;
  text-align: center;
  border-radius: 99999px;
  box-shadow: -1px 1px 10px 0px #2f4c9230;

  .icon {
    width: 24px;
    height: 24px;
    margin: 0 auto 2px;
    display: block;
  }

  > div:hover {
    color: #1643d4;
  }

  .support-widget-btn {
    cursor: pointer;
    .text {
      background: linear-gradient(#00a0ea, #1643d4);
      position: relative;
      margin-left: 2px;
      margin-top: -10px;
      width: 82px;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      line-height: 28px;
      color: #fff;
    }
  }

  .phone {
    position: relative;
    padding-block: 10px;

    .phone-icon {
      width: 32px;
      height: 32px;
    }

    &:hover .phone-pop {
      display: block;
    }

    .phone-pop {
      position: absolute;
      right: 100%;
      top: -6px;
      display: none;
      padding-right: 24px;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));

      .phone-list {
        position: relative;
        white-space: nowrap;
        background: #fff;
        padding: 16px;
        font-size: 16px;
        color: #333;

        .arrow {
          position: absolute;
          left: 100%;
          top: 22px;
          border: 5px solid transparent;
          border-left: 6px solid #fff;
        }
      }
    }
  }

  .wx {
    position: relative;

    .wx-pop {
      position: absolute;
      right: 90%;
      top: -20px;
      display: none;
      width: 180px;
      height: 180px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    &:hover .wx-pop {
      display: block;
    }
  }

  .btn-close {
    background: none;
    outline: none;
    border: none;
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    left: -10px;
    cursor: pointer;
    background: white;
    border-radius: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/module/components/SideService/index.vue